<template>
  <div
    style="
      display: flex;
      align-items: center;
      justify-content: center;
      height: 100%;
    "
  >
    <el-empty :image-size="200" :image="image">
      <template #description>
        <el-text :type>{{ description }}</el-text>
      </template>
      <slot />
    </el-empty>
  </div>
</template>
<script setup>
import image from "@/assets/img/save_success.png";
defineProps({
  description: {
    type: String,
    default: "暂无数据"
  },
  size: {
    type: Number,
    default: 200
  },
  type: {
    type: String,
    default: "info"
  }
});
</script>
<style scoped lang="scss"></style>
